export enum Constants {
  PROFILE_ID = 1,
  PROD_URL = "https://nexverse-api.onrender.com/api",
  LOCAL_URL = "http://localhost:8080/api",
}
